/**
 * Essa função serve para "limpar" objetos com parâmetros vazios e salvar apenas
 * o que possui dado
 */

export function removeValoresVazios(input, excecoes = []) {
  let obj = input;
  if (typeof input === 'string') {
    try {
      obj = JSON.parse(input);
    } catch (e) {
      return input;
    }
  }

  if (Array.isArray(obj)) {
    return obj
      .map((item) => removeValoresVazios(item, excecoes))
      .filter((item) =>
        !(item == null || item === '' ||
          (typeof item === 'object' && Object.keys(item).length === 0))
      );
  } else if (typeof obj === 'object' && obj !== null) {
    return Object.entries(obj)
      .filter(([k, v]) =>
        excecoes.includes(k) ||
        !(v == null || v === '' ||
          (typeof v === 'object' && Object.keys(removeValoresVazios(v, excecoes)).length === 0))
      )
      .reduce((acc, [k, v]) => {
        if (typeof v === 'object' && v !== null) {
          acc[k] = removeValoresVazios(v, excecoes);
        } else {
          acc[k] = v;
        }
        return acc;
      }, {});
  }
  return obj;
}
